import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Run } from '../models/Run'
import { upsertMultipleRuns } from '../runsSlice'

export const fetchRuns = createAsyncThunk('runs/fetch', async (_, { dispatch }) => {
  const runs = await OLMSApiService.get<Run[]>('/run/list')

  if (runs && runs.length > 0) {
    dispatch(upsertMultipleRuns(runs))
  }
})